export const CASH_SESSION_PAYMENT_METHODS = ['cash', 'mercadopago_qr', 'transfer', 'card', 'cheque', 'fiado'] as const;

export type CashPaymentMethodLine = {
  methodId: string;
  total: number;
};

export function buildCashSessionPaymentBreakdown(
  rows: Array<{ method_id?: string; methodId?: string; total?: number }>
): CashPaymentMethodLine[] {
  const byId = new Map<string, number>();
  for (const row of rows) {
    const methodId = String(row.method_id ?? row.methodId ?? '');
    if (!methodId) continue;
    byId.set(methodId, Number(row.total ?? 0));
  }
  return CASH_SESSION_PAYMENT_METHODS.map((methodId) => ({
    methodId,
    total: byId.get(methodId) ?? 0,
  }));
}
